/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFIPDetails
 */
export interface CRSFIPDetails {
    /**
     * 
     * @type {string}
     * @memberof CRSFIPDetails
     */
    issuer: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFIPDetails
     */
    not_after: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFIPDetails
     */
    not_before: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFIPDetails
     */
    sans: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFIPDetails
     */
    subject: string;
}

/**
 * Check if a given object implements the CRSFIPDetails interface.
 */
export function instanceOfCRSFIPDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "issuer" in value;
    isInstance = isInstance && "not_after" in value;
    isInstance = isInstance && "not_before" in value;
    isInstance = isInstance && "sans" in value;
    isInstance = isInstance && "subject" in value;

    return isInstance;
}

export function CRSFIPDetailsFromJSON(json: any): CRSFIPDetails {
    return CRSFIPDetailsFromJSONTyped(json, false);
}

export function CRSFIPDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFIPDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'issuer': json['issuer'],
        'not_after': json['not_after'],
        'not_before': json['not_before'],
        'sans': json['sans'],
        'subject': json['subject'],
    };
}

export function CRSFIPDetailsToJSON(value?: CRSFIPDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'issuer': value.issuer,
        'not_after': value.not_after,
        'not_before': value.not_before,
        'sans': value.sans,
        'subject': value.subject,
    };
}

